<template>
    <div class="container-launch">
        <launch-card v-if="launchData" :data="launchData" />
        <launch-default v-else/>
    </div>
</template>

<script>
	import launchDefault from './components/launch-default'
	import launchCard from './components/launch-card'
	import { launchDay } from '@/services/axios'
	import { mapActions } from 'vuex'

	export default {
		name: 'ui-launch-management-list',

		components: {
			launchDefault,
			launchCard,
		},

		data() {
			return {
				launchData: null
			}
		},

		mounted () {
			this.setPreLoad(true)
			launchDay.store()
				.then(response => {
					if (response.data && response.data.length) this.launchData = [...response.data]
				})
				.catch(error => {
					if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
				})
				.finally(() => {
					this.setPreLoad(false)
				})
		},

		methods: {
			...mapActions('launchDay', ['setPreLoad']),
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>